import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { CurrencyDollarIcon } from "@heroicons/react/20/solid";
import { useVenue } from "../VenueProvider";
import { ACCENT } from "./shared";

// Cinco pestañas (FRA-344): Pagos + Reembolsos + Costos se fundieron en
// Balance general. "Por cobrar" y "Por pagar" van juntas y primero: son las
// dos caras de la misma pregunta —quién me debe, a quién le debo— y leerlas
// seguidas es el uso real. Balance general queda después, ya como resumen.
const TAB_DEFS = [
  { to: "por-cobrar", label: "Por cobrar", color: "#F59E0B" },
  { to: "por-pagar", label: "Por pagar", color: "#DC2626" },
  { to: "balance", label: "Balance general", color: ACCENT },
  { to: "movimientos", label: "Movimientos", color: "#3B82F6" },
  { to: "depositos", label: "Depósitos en garantía", color: ACCENT },
];

const CuentasShell = () => {
  const { selectedVenue } = useVenue();
  return (
    <div className="max-w-6xl mx-auto">
      {/* Header */}
      <div className="flex items-center gap-3 mb-1">
        <CurrencyDollarIcon className="h-6 w-6" style={{ color: ACCENT }} />
        <h1 className="text-xl sm:text-2xl font-bold text-zinc-900 dark:text-white">
          Cuentas
        </h1>
        {selectedVenue && (
          <span className="text-lg text-zinc-400 font-normal hidden sm:inline">
            – {selectedVenue.name}
          </span>
        )}
      </div>
      <p className="text-sm text-zinc-500 mb-6">
        Por cobrar, por pagar, balance general, movimientos y depósitos en garantía.
      </p>

      {/* Tab nav */}
      <div className="rounded-xl border border-zinc-200 dark:border-zinc-700/60 bg-white dark:bg-zinc-800/50 shadow-sm overflow-hidden">
        {/* Cinco pestañas sin scroll horizontal: en móvil se acomodan en dos
            filas; en pantallas medianas las etiquetas largas pueden partirse
            en dos líneas en vez de empujar la barra. */}
        <div className="flex flex-wrap border-b border-zinc-200 dark:border-zinc-700/60">
          {TAB_DEFS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                `basis-1/3 grow sm:basis-0 sm:flex-1 min-w-0 px-2 py-3 text-sm font-semibold leading-tight text-center transition ${
                  isActive
                    ? "text-zinc-900 dark:text-white border-b-2"
                    : "text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-300 border-b-2 border-transparent"
                }`
              }
              style={({ isActive }) => (isActive ? { borderBottomColor: t.color } : undefined)}
            >
              {t.label}
            </NavLink>
          ))}
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default CuentasShell;
